import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { PaymentCredentialsPage } from '@/areas/orders/PaymentCredentialsPage';
import { canViewCustomerPortalSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/customer-portal/payment-credentials')(
    {
        staticData: {
            access: { permissions: canViewCustomerPortalSettings },
            chrome: 'home',
        } satisfies PageStaticData,
        component: RouteComponent,
    },
);

function RouteComponent(): JSX.Element {
    return <PaymentCredentialsPage />;
}
